// extracted by mini-css-extract-plugin
module.exports = {"link":"_1PW5Q","image":"_3p9ul","root":"fOSzc"};